import { render } from "./TheTruDenGiaoThong.vue?vue&type=template&id=562c9bcc"
import script from "./TheTruDenGiaoThong.vue?vue&type=script&lang=js"
export * from "./TheTruDenGiaoThong.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__